// Page names
export const INSTRUCTIONS = 'instructions'
export const ORDERS = 'orders'
export const PIG_INFO = 'pig information'
export const SUPPLIERS = 'suppliers'
export const PRODUCTS = 'products'
export const CUSTOMERS = 'customers'

export const PER_PAGE_OPTIONS = [250, 500, 750, 1000]
export const PER_PAGE_MAX = 1000
